import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { withSize } from '@bd/bdcore-utilities';


import PageWrapper from '../../components/PageWrapper';
import CTAComponent from '../../components/CTAComponent';
import CommunityDirections from './CommunityDirections';
import CommunityHeader from './CommunityHeader';
import CommunityDetails from './CommunityDetails';
import CommunityWelcome from './CommunityWelcome';
import CommunitySchools from './CommunitySchools';
import CommunityPhotos from './CommunityPhotos';
import CommunityHomes from './CommunityHomes';
import CommunityPlans from './CommunityPlans';
import CommunityVideos from './CommunityVideos';
import LotResults from './LotResults';

const styles = css`
  &.CommunityDetail_wrapper {
    padding: 30px 0;
    @media(min-width: 992px) {
      padding: 130px 0;
    }
  }
  &.altStyles {
    @media (min-width: 992px) {
      padding: 60px 0;
    }
  }
`;


function CommunityDetail({ community, size, homes, plans, lots }) {
  const homeLots = lots.filter(item => get(item, 'lot'));
  return (
    <PageWrapper singlePage>
      <PageHelmet community={community} />
      <CommunityHeader community={community} />
      <CommunityDetails community={community} />
      <div
        className={`${styles} ${size.width >= 992 && 'container'} ${get(community, 'external_link_banner[0].external_url') && 'altStyles'} CommunityDetail_wrapper`}
        id="about"
      >
        <div className="d-lg-flex aboutSection">
          <div className="col-lg-7 px-0">
            <CommunityWelcome community={community} />
          </div>
          <div className="col-lg-4 ml-lg-auto px-0">
            <CommunitySchools community={community} />
          </div>
        </div>
      </div>
      {
        get(community, 'custom_videos').length > 0 &&
        <CommunityVideos community={community} />
      }
      {
        get(community, 'photos') &&
        <CommunityPhotos community={community} />
      }
      {
        homes && homes.length > 0 &&
        <CommunityHomes community={community} homes={homes} />
      }
      {
        homeLots && homeLots.length > 0 &&
        <LotResults homeLots={homeLots} />
      }
      {
        plans && plans.length > 0 &&
        <CommunityPlans community={community} plans={plans} />
      }
      <CommunityDirections community={community} />
      <CTAComponent type="Community" />
    </PageWrapper>
  );
}

CommunityDetail.propTypes = {
  size: PropTypes.object.isRequired,
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
  lots: PropTypes.arrayOf(PropTypes.object),
};
CommunityDetail.defaultProps = {
  homes: undefined,
  plans: undefined,
  lots: undefined,
};

export default withData(
  {
    homes: true,
    community: true,
    plans: true,
    lots: true,
  },
  {
    ifMissing404: true,
  },
)(withSize()(CommunityDetail));



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/index.js